import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { SafeUrl } from '@angular/platform-browser';

export interface QrDialogData {
  title: string;
  // fileName: string;
  // objectUrl: string;
  // preview: any;
  qrData: string;
}

@Component({
  selector: 'app-qr-dialog',
  templateUrl: './qr-dialog.html',
  styleUrls: ['./qr-dialog.scss'],
})
export class QrDialog implements OnInit {
  qrData: string = null;
  qrCodeDownloadLink: SafeUrl = '';
  constructor(
    private dialogRef: MatDialogRef<QrDialog>,
    @Inject(MAT_DIALOG_DATA) public data: QrDialogData
  ) {}

  ngOnInit() {
    this.qrData = this.data.qrData;
    console.log(this.qrData);
  }

  onChangeURL(url: SafeUrl) {
    this.qrCodeDownloadLink = url;
  }

  // downloadQr() {
  //   const a = window.document.createElement('a');
  //   a.download = this.data.fileName;
  //   a.href = this.data.objectUrl;
  //   a.click();
  // }

  closeDialog() {
    this.dialogRef.close();
  }
}
